<template>
    <div>

        <h1> 提现金额选项配置 </h1>

        <el-input
            type="textarea"
            :rows="11"
            placeholder="请输入内容"
            v-model="text">
        </el-input>

        <el-button type="primary" @click="okClick">提交</el-button>

    </div>
</template>
  
  
<script>
  // 引入组件及方法
  
  export default {
    components: {  },
    data() {
      return {
        text:""
      };
    },
    mounted(){

      this.$https('GET_MONEY_CONFIG', {}).then(res => {
        console.log("获取提现金额选项", res)
        this.text = JSON.stringify( res.data.options )


      })



    },
    methods: {
        okClick(){
            
            this.$https("MONEY_CONFIG", {options:JSON.parse(this.text)}).then(res => {
                this.$message.success('提交成功')
            })
        }
    },
  };
</script>
  
<style></style>
  